import script from "./ModalParametrosPrimeraRondaEquipo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalParametrosPrimeraRondaEquipo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalParametrosPrimeraRondaEquipo.vue?vue&type=style&index=0&id=df1ed896&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df1ed896"]])

export default __exports__